import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import "./control.css";
import { Button } from "../button/button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle, faUndo } from "@fortawesome/free-solid-svg-icons";
import React from "react";
export const Control = ({ name, children, reset, value, onChange, showOutput, tooltip, }) => {
    const [v, setV] = useState(value);
    const isPrimitive = value == null || ['string', 'number', 'boolean'].includes(typeof value);
    const [displayValue, setDisplayValue] = useState(isPrimitive ? String(value) : JSON.stringify(value));
    useEffect(() => {
        setV(value);
        setDisplayValue(isPrimitive ? String(value) : JSON.stringify(value));
    }, [value, isPrimitive]); // Recompute on value change
    return (_jsx("div", { className: "control-wrapper", children: _jsx("div", { className: "control", children: _jsxs("div", { className: "children", children: [_jsxs("div", { className: "label-row", children: [_jsxs("label", { children: [name, ":"] }), value !== null && onChange && showOutput && (_jsx("input", { value: displayValue, onChange: (evt) => setDisplayValue(evt.target.value), className: "border-0 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:border-2", type: "text", onBlur: (evt) => {
                                    try {
                                        const parsedValue = isPrimitive ? displayValue : JSON.parse(displayValue);
                                        // Fake a ChangeEvent with the parsed value for onChange
                                        const fakeEvent = {
                                            ...evt,
                                            target: { ...evt.target, value: parsedValue },
                                        };
                                        onChange(fakeEvent);
                                    }
                                    catch (error) {
                                        console.error('Invalid JSON:', error);
                                        // Revert to original on error
                                        setDisplayValue(isPrimitive ? String(value) : JSON.stringify(value));
                                    }
                                } })), name === "Image" && value && (_jsx("div", { className: "checkerboard", children: _jsx("img", { src: value, width: 48, height: 48, alt: "Preview", style: { display: "block" } }) }))] }), _jsxs("div", { className: "input-row", children: [React.Children.map(children, (child) => {
                                if (React.isValidElement(child)) {
                                    if (name === "Image") {
                                        return React.cloneElement(child, {
                                            type: "file",
                                            accept: "image/*",
                                            onChange,
                                        });
                                    }
                                    else {
                                        return React.cloneElement(child, { value, onChange, reset });
                                    }
                                }
                                return child;
                            }), _jsx(Button, { kind: "transparent", onClick: reset, tooltip: "Reset", children: _jsx(FontAwesomeIcon, { icon: faUndo, style: { color: '#b91c1c' } }) }), tooltip && (_jsx(Button, { kind: "transparent", onClick: () => null, tooltip: tooltip, children: _jsx(FontAwesomeIcon, { icon: faQuestionCircle, style: { color: '#64748b' } }) }))] })] }) }) }));
};
